/**
  * 浅色背景 竖堆叠柱状图
  * @param unit 单位
  * @param xData []x轴数据
  * @param dataArr [{name:'',data:[]}]数据合集
*/
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let option = {
    color: EchartsLightColor,
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: function (params) {
        let result = params[0].name + "<br>";
        params.forEach(function (item) {
          result +=
            item.marker +
            " " +
            item.seriesName +
            " : " +
            dealBigNum(item.value) +
            paramObj.unit +
            "</br>";
        });
        return result;
      },
    },
    legend: {},
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#CBCBCB",
          fontSize: 12,
        },
        data: paramObj.xData,
      },
    ],
    yAxis: [
      {
        type: "value",
        name: `单位(${paramObj.unit})`,
        nameTextStyle: {
          color: "#666",
          fontSize: 12,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisLabel: {
          color: "#999",
          fontSize: 12,
        },
        splitLine: {
          lineStyle: {
            type: "solid",
            color: "#EBEBEB",
          },
        },
      },
    ],
    dataZoom: [
      {
        type: "inside",
      },
    ],
    series: [],
  };
  paramObj.dataArr.forEach((v, i) => {
    option.series.push({
      name: v.name,
      type: "bar",
      stack: "total",
      barMaxWidth: 16,
      itemStyle:
        i == paramObj.dataArr.length - 1
          ? { borderRadius: [12, 12, 0, 0] }
          : {},
      emphasis: {
        focus: "series",
      },
      data: v.data,
    });
  });
  

  return option
  
}